import * as React from 'react';
import classnames from 'classnames';

import { expandDataProps } from 'utils/helper/common';

import './table-row.scss';

import type { Data } from 'types';

type Props = {
  align?: 'center' | 'top',
  minHeight?: 'none' | 'normal',
  highlighted?: boolean,
  className: string,
  children: React.ReactNode,
  nowrap?: boolean,
  data?: Data,
  disabled?: boolean,
  withHover?: boolean,
  onClick?: (event: React.MouseEvent<Element, MouseEvent>) => void
};

class TableRow extends React.PureComponent<Props> {
  static defaultProps = {
    align: 'center',
    minHeight: 'normal',
    className: ''
  };

  render(): React.ReactNode {
    const { align, minHeight, highlighted, children, onClick, className, data, nowrap, disabled, withHover } = this.props;

    const classes = classnames({
      'table-row': true,
      'table-row--disabled': disabled,
      'table-row--highlighted': highlighted,
      'table-row--nowrap': nowrap,
      'table-row--clickable': onClick,
      'table-row--with-hover': Boolean(withHover),
      [`table-row--align-${align}`]: align,
      [`table-row--min-height-${minHeight}`]: minHeight,
      [className]: className
    });

    return (
      <div
        className={classes}
        onClick={onClick ?? undefined}
        {...expandDataProps(data)}
      >
        {children}
      </div>
    );
  }
}

export default TableRow;
